export default "__VITE_ASSET__DrhVQd0v__"